import React from "react";

const RightIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="14" fill="#0f1560" />
      <path
        d="M19.2463 11.0162L13.0095 17.9039C12.9542 17.9654 12.8791 18 12.8006 18C12.7222 18 12.647 17.9654 12.5917 17.9039L9.42036 14.4015C9.36467 14.3405 9.33334 14.2575 9.33334 14.1709C9.33334 14.0842 9.36467 14.0012 9.42036 13.9402L9.83223 13.4853C9.88747 13.4238 9.96266 13.3892 10.0411 13.3892C10.1195 13.3892 10.1947 13.4238 10.25 13.4853L12.7977 16.2989L18.4167 10.0935C18.5331 9.96885 18.7181 9.96885 18.8345 10.0935L19.2463 10.5548C19.302 10.6158 19.3333 10.6989 19.3333 10.7855C19.3333 10.8721 19.302 10.9552 19.2463 11.0162Z"
        fill="white"
      />
    </svg>
  );
};

export default RightIcon;